import createIcon from '../../createIcon';

/**
 * @component @name CoffeeMaker
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNlY0SDIwVjJINkM0LjkgMiA0IDIuOSA0IDRWMjBDNCAyMS4xIDQuOSAyMiA2IDIySDIwVjIwSDE1Ljk3QzE3LjIgMTkuMDkgMTggMTcuNjQgMTggMTZWMTFIOFYxNkM4IDE3LjY0IDguODEgMTkuMDkgMTAuMDMgMjBINlY0SDhWNkM4IDYuNTUgOC40NSA3IDkgN0gxN0MxNy41NSA3IDE4IDYuNTUgMTggNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMyAxMEMxMy41NTIzIDEwIDE0IDkuNTUyMjggMTQgOUMxNCA4LjQ0NzcyIDEzLjU1MjMgOCAxMyA4QzEyLjQ0NzcgOCAxMiA4LjQ0NzcyIDEyIDlDMTIgOS41NTIyOCAxMi40NDc3IDEwIDEzIDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CoffeeMaker = createIcon('CoffeeMaker', [
  [
    'path',
    {
      d: 'M18 6V4H20V2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H20V20H15.97C17.2 19.09 18 17.64 18 16V11H8V16C8 17.64 8.81 19.09 10.03 20H6V4H8V6C8 6.55 8.45 7 9 7H17C17.55 7 18 6.55 18 6Z',
      key: 'q8mu2j',
    },
  ],
  [
    'path',
    {
      d: 'M13 10C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8C12.4477 8 12 8.44772 12 9C12 9.55228 12.4477 10 13 10Z',
      key: '71s4vj',
    },
  ],
]);

export default CoffeeMaker;
